export const stripUrlToDomain = (url: string | null | undefined) => {
  if (!url) return url;
  try {
    // Remove protocol (http, https, etc.)
    let strippedUrl = url.replace(/(^\w+:|^)\/\//, '');
    // Remove www. if present
    strippedUrl = strippedUrl.replace(/^www\./, '');
    // Extract domain part before first slash
    const domain = strippedUrl.split('/')[0];
    // Remove TLD and anything after (e.g., .com, .co.uk, etc.)
    // This will split by '.' and take the first part (after www)
    const domainParts = domain.split('.');
    // If domain is like google.com or google.co.uk, take the first part
    // If domain is like subdomain.google.com, take the second part
    // We'll take the last part before the TLD
    if (domainParts.length >= 2) {
      return domainParts[domainParts.length - 2];
    }
    return domainParts[0];
  } catch {
    return url;
  }
};

export const stripUrlToDomainWithTld = (url: string | null | undefined) => {
  if (!url) return url;
  try {
    // Remove protocol (http, https, etc.)
    let strippedUrl = url.replace(/(^\w+:|^)\/\//, '');
    // Remove www. if present
    strippedUrl = strippedUrl.replace(/^www\./, '');
    // Extract domain part before first slash
    const domain = strippedUrl.split('/')[0];
    // Remove TLD and anything after (e.g., .com, .co.uk, etc.)
    // This will split by '.' and take the first part (after www)
    const domainParts = domain.split('.');
    // If domain is like google.com or google.co.uk, take the first part
    // If domain is like subdomain.google.com, take the second part
    // We'll take the last part before the TLD
    if (domainParts.length >= 2) {
      return `${domainParts[domainParts.length - 2]}.${
        domainParts[domainParts.length - 1]
      }`;
    }
    return `${domainParts[0]}.${domainParts[1]}`;
  } catch {
    return url;
  }
};
